export default __webpack_public_path__ + "static/media/aboutUs-growth-economy@2x.3aa4a9b1.png";